import { i18n, MessageDescriptor } from "@lingui/core";

export { type MessageDescriptor, i18n };

export const locales = {
  en: "English",
  zh: "Chinese",
};

export const defaultLocale = "en";

export async function loadLocale(locale: string) {
  const { messages } = await import(`../../locales/${locale}.po`);
  i18n.loadAndActivate({ locale, messages });
}

export async function initI18n() {
  const savedLocale = localStorage.getItem("locale") || defaultLocale;

  try {
    await loadLocale(savedLocale);
  } catch (error) {
    localStorage.removeItem("locale");
    await loadLocale(defaultLocale);
  }
}

export function getTranslatedString(value: string | MessageDescriptor): string {
    if (typeof value === 'string') {
        return value;
    }
    return i18n._(value);
} 